import { RestAddress } from '../../../hooks/useAddress';
import { COUNTRIES } from '../../../constants';

export const humanizeAddress = ({
  attributes: { addressLine1, addressLine2, city, state, postalCode, countryCode }
}: RestAddress) => {
  const country = COUNTRIES.find(country => country.alpha2Code === countryCode);
  return [
    [addressLine1, addressLine2].filter(Boolean).join(' '),
    city,
    state,
    postalCode,
    country?.name
  ]
    .filter(Boolean)
    .join(', ');
};
